<template>
  <div>
    <div v-if="mode==='LIST'">
      <div class="clearfix">
        <div class="float-left bolder indigo-text text-bolder">
          <h3 class="page-title"><mdb-icon icon="users" /> 학생 관리</h3>
        </div>
        <div class="float-right">
            <mdb-btn  icon="user-plus" class="p-1" @click="onAddMember" :disabled="!org.prefix">추가</mdb-btn>
        </div>
      </div>
      <student-list :students="students" :status="status" @change-mode="onChangeMode"/>
    </div>
    <div v-if="mode==='VIEW'">
      <h3 class="page-title"><mdb-icon icon="user" /> 학생 정보</h3>
      <student :student="student" :status="status"
        @change-mode="onChangeMode" @change-profile="onChangeProfile"
        @remove="onRemmove"/>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';
import studentList from '@/components/member/StudentList'
import student from '@/components/member/Student'

export default {
  name: 'StaffStudentManagePage',
  components: { studentList, student },
  data: () => ({
    students: [],
    status: {},
    student: {},
    mode: 'LIST'
  }),
  computed: {
    ...mapState('auth', ['org']),
    ...mapState('training', ['training'])
  },
  methods: {
    onChangeMode (mode, userId) {
      this.mode = mode;
      if (mode === 'VIEW') {
        this.student = this.students.find(s => s.userId === userId)
      }
    },
    async load () {
      if (!this.training || !this.training._id) {
        this.students = []
        return
      }
      this.students = await this.$member.studentList(this.training._id);
      this.status = this.students.reduce((set, s) => set.add(s.status), new Set(['모두']));
    },
    onAddMember () {
      this.$router.push({ name: 'StaffStudentAddPage' })
    },
    onChangeProfile () {
      this.$router.push({ name: 'StaffStudentEditPage', query: { student: this.student._id } })
    },
    async onRemmove (student) {
      if (!confirm(`${student.userId}(${student.name}) 수강생을 삭제할까요?`)) {
        return
      }
      await student.delete()
      const ix = this.students.find(s => s._id === student._id)
      this.students.splice(ix, 1)
      this.mode = 'LIST'
    }
  },
  created () {
    this.load()
  },
  watch: {
    training: 'load'
  }
}
</script>
